import type { z } from 'zod'

import { baseRegistrySchema } from '@/registry'

/**
 * Scalar rules
 *
 * Currently only supports Spectral rulesets.
 */
export const ruleSchema = baseRegistrySchema.extend({}).meta({ id: 'rule' })

export type Rule = z.infer<typeof ruleSchema>
